import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import PageBase from '../../../widgets/PageBase/PageBase';
import { Button, MenuItem, Select, TextField, Hidden } from '@material-ui/core';
import './BranchOverridePage.css';
import DataTable from '../../../widgets/data-table/DataTable/DataTable';
import * as UserType from '../../../../constants/UserType';
import DataTablePagination from '../../../widgets/data-table/DataTable/DataTablePagination/DataTablePagination';
import { Checkbox } from 'material-ui';

const ADD_ACTION = 1;

const columns = (props) => [
  {
    header: {
      display: 'Employee ID'
    },
    accessor: (employee) => ({
      display: employee.employeeId
    })
  },
  {
    header: {
      display: 'Branch Code'
    },
    accessor: (employee) => ({
      display: employee.branchCode
    })
  },
  {
    header: {
      display: 'Branch Description'
    },
    accessor: (employee) => ({
      display: employee.branchDescription
    })
  },
  {
    header: {
      display: 'Branch Role'
    },
    accessor: (employee) => ({
      display: props.intl.formatMessage({
        id: UserType[employee.jobFunction].displayName
      })
    })
  },
  {
    header: {
      display: 'Title'
    },
    accessor: (employee) => ({
      display: employee.jobTitle
    })
  },
  {
    header: {
      display: 'Employee Name'
    },
    accessor: (employee) => ({
      display: employee.employeeName
    })
  },
  {
    header: {
      display: 'Is Override'
    },
    accessor: (employee) => ({
      display: <Checkbox checked={employee.isOverride} disabled />
    })
  }
];

const BranchOverridePage = (props) => {
  const getData = () =>
    props.employees
      .sort((a, b) => a.branchCode.localeCompare(b.branchCode))
      .map((employee) => ({
        ...employee
      }));

  return (
    <div>
      <PageBase navigation={['Branch Override']} includeInactiveBranches>
        <div className="row">
          <div className="col-xs-12 col-md-8 col-md-offset-2">
            <DataTable
              columns={columns(props)}
              bodyData={getData()}
              footerContent={
                <DataTablePagination
                  page={props.page}
                  onChangePage={props.handleChangePage}
                  onChangeRowsPerPage={props.handleChangeRowsPerPage}
                  rowsPerPageOptions={props.rowsPerPageOptions}
                />
              }
            />
          </div>
        </div>
        <div className="row col-xs-12 col-md-12">
          {props.branchCode != null ? (
            <form onSubmit={props.onAction}>
              <div className="row col-xs-11 col-md-11">
                <h3>
                  {props.intl.formatMessage({
                    id: 'manage_branch_override'
                  })}
                </h3>
              </div>
              <div className="row">
                <Select
                  className="col-xs-12 col-md-2 input-element"
                  value={props.selectedAction}
                  onChange={(event) => {
                    props.onChangeAction(event.target.value);
                  }}
                >
                  {props.actions.map((action, index) => (
                    <MenuItem key={index} value={action.value}>
                      {props.intl.formatMessage({
                        id: action.displayName
                      })}
                    </MenuItem>
                  ))}
                </Select>
                <TextField
                  placeholder="EmployeeId"
                  fullWidth
                  className="col-xs-12 col-md-2 input-element"
                  value={props.employeeId}
                  type="number"
                  onChange={(event) =>
                    props.onEmployeeIdChange(event.target.value)
                  }
                />
                <Hidden xsUp={props.selectedAction !== ADD_ACTION}>
                  <Select
                    className="col-xs-12 col-md-5 input-element"
                    value={props.selectedApprovalTier}
                    onChange={(event) => {
                      props.onChangeApprovalTier(event.target.value);
                    }}
                  >
                    {props.approvalTiers.map((approvalTier, index) => (
                      <MenuItem key={index} value={approvalTier.value}>
                        {props.intl.formatMessage({
                          id: approvalTier.displayName
                        })}
                      </MenuItem>
                    ))}
                  </Select>
                </Hidden>
                <span className="btn-search input-element">
                  <Button
                    onClick={props.onAction}
                    color="primary"
                    disabled={!props.employeeId || props.employeeId === ''}
                    type="submit"
                  >
                    {props.intl.formatMessage({
                      id: 'action.submit'
                    })}
                  </Button>
                </span>
              </div>
            </form>
          ) : null}
        </div>
      </PageBase>
    </div>
  );
};

BranchOverridePage.propTypes = {
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  employees: PropTypes.arrayOf(PropTypes.object.isRequired),
  action: PropTypes.arrayOf(PropTypes.object.isRequired),
  ApprovalTiers: PropTypes.arrayOf(PropTypes.object.isRequired),
  handleChangePage: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,
  onEmployeeIdChange: PropTypes.func.isRequired,
  onChangeApprovalTier: PropTypes.func.isRequired,
  onChangeAction: PropTypes.func.isRequired
};

export default injectIntl(BranchOverridePage);
